<template>
  <div style="background: white; width: 100% position: absolute;">
    <!-- <div style="position: absolute; top: 10; left; 10" id="backButton">
      <font-awesome-icon @click="goBack" class="menuIcon" icon="arrow-left" />
    </div> -->
    <img src="/se_logo_full.png" style="width: 300px; max-width: 90%" />
    <h1 class="title is-3">{{ header }}</h1>
    <div v-if="status == 1">
      <div v-if="!$store.getters.currentSeason.schedules.length">
        <br />
        <p>No schedules to export. Create one first!</p>
        <br />
        <Button class="p-button-lg" label="Create Schedule" @click="goRouter('/schedules/new')" />
      </div>

      <div
        v-for="schedule in $store.getters.currentSeason.schedules"
        :key="schedule.id"
        class="p-col-12 rounded paddedCol whiteBg p-my-3 expand"
      >
        <div class="p-grid p-text-left">
          <div class="p-col-12">
            <h3 class="title is-3">
              {{ schedule.name }}
              <Button class="floatRight" label="EXPORT" />
            </h3>
          </div>
          <div class="p-col-12">
            <strong> Divisions </strong>
            <div>
              <span v-for="(x, i) in schedule.divisions" :key="x.id">
                <router-link :to="`/divisions/${x.id}`">{{ x.name }}</router-link>
                <span v-if="i < schedule.divisions.length - 1">,</span>
              </span>
            </div>
          </div>
          <div class="p-col-12">
            <strong> Results </strong>
            <div>{{ schedule.scheduled }} scheduled, {{ schedule.unscheduled }} unscheduled</div>
          </div>
          <div class="p-col-12">
            <strong> Created </strong>
            <div>
              {{ new Date(schedule.created_at).toLocaleString() }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-grid p-justify-center cursorpointer" v-if="status == 0">
      <div class="p-col-12">What would you like to do?</div>
      <div class="p-col-12">
        <Button
          class="dsButton seButton p-button-lg"
          @click="goRouter('/sportsengine/import-beta')"
          label="Import Data from Season Management"
        />
      </div>
      <div class="p-col-12 mb-4">
        <Button
          class="dsButton seButton p-button-lg"
          @click="goRouter('/sportsengine/export?type=season')"
          label="Export Schedule(s) to Season Management"
        />
      </div>
<!--      <div class="p-col-12 mb-4">-->
<!--        <Button class="dsButton seButton p-button-lg" label="Delete Games from Season Management" />-->
<!--      </div>-->
      <div class="p-col-12">
        <Button
          class="dsButton seButton p-button-lg"
          @click="goRouter('/sportsengine/import')"
          label="Import Data from Sport Management"
        />
      </div>
      <div class="p-col-12">
        <Button
          class="dsButton seButton p-button-lg"
          @click="goRouter('/sportsengine/export')"
          label="Export Schedule(s) to Sport Management"
        />
      </div>
      <div class="p-col-12 mb-4">
        <Button
          class="dsButton seButton p-button-lg"
          @click="goRouter('/sportsengine/delete')"
          label="Delete Games from Sport Management"
        />
      </div>
      <div class="p-col-12">
        <Button class="dsButton seButton p-button-lg" @click="tryReconnect" label="Reconnect SportsEngine" />
      </div>
      <div class="p-col-12">
        <Button class="p-button-outlined p-button-large p-mt-5" @click="goRouter('/')" label="Exit SportsEngine Page" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  // ddd
  data() {
    return {
      status: 0,
      warned: false,
    };
  },
  computed: {
    header() {
      if (this.status == 1) {
        return "Export Schedules";
      } else if (this.status == 2) {
        return "Delete Games";
      } else {
        return "Account Connected!";
      }
    },
  },
  methods: {
    tryReconnect() {
      if (this.warned) {
        this.reconnectSportsengine();
        return;
      }
      alert(
        "Connecting your SportsEngine account will disconnect the currently connected SE account within Diamond Scheduler. If you are not the owner of this Diamond Scheduler account (e.g. you are staff), please do NOT connect your account, but rather ask your account owner to re-connect theirs so that proper permissions are maintained. If you do own this account and would like to attach your SportsEngine account, please press the RECONNECT button again to proceed.",
      );
      this.warned = true;
    },
    goBack() {
      if (this.status != 0) {
        this.status = 0;
      } else {
        this.goRouter("/");
      }
    },
    // exportSchedule(schedule) {
    //   this.trackEvent("Started SportsEngine Export", { schedule: schedule });
    //   var x = window.confirm(
    //     "You about to send the schedule '" +
    //       schedule.name +
    //       "' with " +
    //       schedule.scheduled +
    //       " games to SportsEngine. Press OK to continue or cancel to not proceed."
    //   );
    //   if (x) {
    //     this.trackEvent("Confirmed SportsEngine Export", {
    //       schedule: schedule,
    //     });
    //     api
    //       .exportScheduleSportsengine(schedule.id)
    //       .then(() => {
    //         this.makeToast(
    //           "success",
    //           "Sent schedule to SportsEngine!",
    //           "Please allow for up to 30 minutes for full syncing, depending on schedule size. Don't export the schedule again during this time.",
    //           10000
    //         );
    //       })
    //       .catch((e) => {
    //         this.makeToast("error", "Could not send schedule: " + e);
    //       });
    //   } else {
    //     this.trackEvent("Cancelled SportsEngine Export", {
    //       schedule: schedule,
    //     });
    //     this.makeToast("info", "Action Cancelled - Schedule not sent");
    //   }
    // },
    clearAll() {
      this.trackEvent("Started SportsEngine Clear", {});
      var x = window.confirm(
        "You about to clear ALL Diamond Scheduler created games from your SportsEngine account. Press OK to continue or cancel to not proceed",
      );
      if (x) {
        this.trackEvent("Confirmed SportsEngine Clear", {});
        api
          .deleteAllSportsEngine(this.$store.getters.currentSeason.se_id)
          .then(() => {
            this.makeToast(
              "success",
              "Game clearing in progress!",
              "Please allow for up to 15 minutes for full deletion, depending on game count. Don't clear the games again during this time.",
              10000,
            );
          })
          .catch(e => {
            this.makeToast("error", "Could clear games: " + e);
          });
      } else {
        this.trackEvent("Cancelled SportsEngine Clear", {});
        this.makeToast("info", "Action Cancelled - No games deleted");
      }
    },
  },
  watch: {
    "$route.params.export": function(id) {
      console.log("New path");
    },
  },
  created() {},
  mounted() {
    window.analytics.page();
    if (this.getURLParam("export")) {
      this.status = 1;
    }
  },
};
</script>

<style scoped lang="scss">
.seButton {
  width: 450px;
  max-width: 95%;
  margin: 0 auto;
}
</style>
